import { useEffect } from "react";

const SITE_URL = process.env.REACT_APP_BACKEND_URL || "";
const DEFAULT_OG = "https://customer-assets-lqy194kg.emergentagent.net/job_travel-cms-hub-5/artifacts/2ilf7odo_Final%20LOGO.png";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// SEO: title, meta description, canonical, Open Graph, Twitter, JSON-LD
export default function Seo({ title, description, image, path = "", jsonLd = null, type = "website" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · VacanzaGo` : "VacanzaGo — Travel · Events · Experiences";
    const url = `${window.location.origin}${path || window.location.pathname}`;
    const img = image || DEFAULT_OG;

    document.title = fullTitle;
    upsertMeta("name", "description", description || "");
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description || "");
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:site_name", "VacanzaGo");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description || "");
    upsertMeta("name", "twitter:image", img);

    // JSON-LD structured data
    const existing = document.getElementById("page-jsonld");
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, image, path, type, jsonLd]);

  return null;
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  name: "VacanzaGo",
  description: "Premium travel, pilgrimage and event management from Haridwar since 2016.",
  telephone: "+91 82170 05513",
  email: "info@vacanzago.com",
  address: { "@type": "PostalAddress", addressLocality: "Haridwar", addressRegion: "Uttarakhand", addressCountry: "IN" },
  areaServed: "IN",
};
